// THIS FILE IS AUTO-GENERATED. DO NOT EDIT. Re-run --exportTsApi to regenerate.
export enum AlertSeverity {
	Info = 0,
	Warning = 1,
	Critical = 2,
}

export const AlertSeverityDisplayNames: { [key in keyof typeof AlertSeverity]?: string} = {
	"Info": "Info",
	0 : "Info",
	"Warning": "Warning",
	1 : "Warning",
	"Critical": "Critical",
	2 : "Critical",
}

export const getAlertSeverityDisplayName = (key: AlertSeverity | (keyof typeof AlertSeverity & string)) => {
	return AlertSeverityDisplayNames[key];
}

